import React, { FunctionComponent } from 'react';
import { Col, ColProps } from 'reactstrap';

const CustomCol: FunctionComponent<ColProps> = (props: ColProps) => {
    const newProps = {
        ...props,
        widths: ['xs', 'sm', 'md', 'lg', 'xl', 'xxl']
    };
    //@ts-ignore
    return <Col {...newProps} />;
};

export default CustomCol;
